import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Pencil1Icon } from '@radix-ui/react-icons';
import { IconButton } from '@producer/ui-kit';

import { Building } from '../../../components/icons';
import { Phone } from '../../../components/icons/Phone';
import { ContactInfoModal } from './contact-info.modal';
import { CollapsibleItem } from '../../../components/collapsible-item/collapsible-item';
import { ConditionalWrapper } from '../../../components/conditional-wrapper/conditional-wrapper';
import { useResponsive } from '../../../hooks/useResponsive';
import { CellLabel, HorizontalCell } from './styled-mobile-table';
import { Address } from '../../../dto/common/address.dto';

import styles from './info-widget.module.scss';
type InfoWidgetProps = {
  stepId: string;
  title: string;

  info: {
    name?: string;
    phone?: string;
    address?: Address;
  };

  onUpdate: (values: any) => Promise<any>;
};

export const InfoWidget: React.FC<InfoWidgetProps> = observer(({ title, info, onUpdate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { name, phone, address } = info;
  const { isDesktop } = useResponsive();

  const handleSubmit = async (values: any) => {
    await onUpdate(values);
    setIsModalOpen(false);
  };

  return (
    <div className={styles['container']}>
      {isDesktop && (
        <div className={styles['header']}>
          <div className={styles['invisible']} />

          <div className={styles['title']}>{title}</div>

          <IconButton icon={<Pencil1Icon />} onClick={() => setIsModalOpen(true)} />
        </div>
      )}

      <ConditionalWrapper
        condition={!isDesktop}
        wrapper={(children) => (
          <CollapsibleItem
            title={title}
            triggerType="default-small"
            titleAlignment="center"
            isTransparent
          >
            <div className={styles['container']}>{children}</div>
          </CollapsibleItem>
        )}
      >
        <div className={styles['info-wrapper']}>
          <div className={styles['field-container']}>
            <div className={styles['address-field']}>
              <Building />

              <div>
                {name && <div className={styles['text']}>{name}</div>}

                {address?.line1 && <div className={styles['text']}>{address.line1}</div>}

                {(address?.postalCode || address?.city) && (
                  <div className={styles['text']}>
                    {address.postalCode} {address.city}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={styles['address-field']}>
            <Phone />

            <div className={styles['text']}>{phone}</div>
          </div>
        </div>

        {!isDesktop && (
          <HorizontalCell className={styles['actions-container']}>
            <CellLabel>Actions</CellLabel>

            <IconButton
              variant="dark"
              icon={<Pencil1Icon />}
              onClick={() => setIsModalOpen(true)}
              size="small"
            />
          </HorizontalCell>
        )}
      </ConditionalWrapper>

      {isModalOpen && (
        <ContactInfoModal
          title={title}
          onSubmit={handleSubmit}
          defaultValues={info}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
});
